import { NameSpecifiedEntity } from "../entity/NameSpecifiedEntity";
import { Department } from "./Department";

export class DepartmentGroup extends NameSpecifiedEntity<string> {
  constructor(id: string, name: string, public departments: Department[], public isDeleted: boolean = false) {
    super(id, name);
  }

  clone(): DepartmentGroup {
    return new DepartmentGroup(this.id, this.name, this.departments, this.isDeleted);
  }
}
